// extracted by mini-css-extract-plugin
export default {"warningIcon":"PersonWarning__warningIcon___aDxmB"};